import { FaRegTrashAlt } from "react-icons/fa";
import { HiTv } from "react-icons/hi2";
import {
	TbBallFootball,
	TbBroadcast,
	TbBroadcastOff,
	TbClockQuestion,
	TbCopyCheck,
} from "react-icons/tb";

import type { BroadcastSummary } from "../../../types/broadcasts.types";
import type { ToolbarOptionConfig } from "../../toolbar-dropdown/toolbar-dropdown.types";

/**
 * Utility for getting the options available for the broadcast, such
 * as end broadcast, pause broadcast, delete broadcast.
 *
 * End broadcast: Should show up if the broadcast is in progress
 * Pause broadcast: Should show up if the broadcast is in progress
 * Delete broadcast Show show up if the broadcast has been ended.
 *
 * Accepts: Whatever information me need about the broadcast.
 *
 * @returns Array of toolbar options
 */
export const getBroadcastOptions = (
	status: BroadcastSummary["status"],
): ToolbarOptionConfig[] => {
	const options: ToolbarOptionConfig[] = [];

	if (status === "live") {
		options.push({
			id: "end-broadcast",
			label: "End broadcast",
			icon: TbBroadcastOff,
		});
		options.push({
			id: "pause-broadcast",
			label: "Pause broadcast",
			icon: TbBroadcast,
		});
	}

	if (status === "ended") {
		options.push({
			id: "delete-broadcast",
			label: "Delete broadcast",
			icon: FaRegTrashAlt,
		});
	}

	options.push({
		id: "copy-link",
		label: "Copy viewer link",
		icon: TbCopyCheck,
	});

	return options;
};

/**
 * Utility for getting the options available for the match, such as
 * kick off, half time, var review, full time.
 *
 * Accepts: Whatever information me need about the game, to determine
 * the options we can show.
 *
 * @returns Array of toolbar options
 */
export const getMatchOptions = (
	startTime: string | null,
	halfTimeAt: string | null,
	secondHalfStartTime: string | null,
	fullTimeAt: string | null,
	varReview: boolean,
): ToolbarOptionConfig[] => {
	const options: ToolbarOptionConfig[] = [];

	if (!startTime) {
		options.push({ id: "kick-off", label: "Kick off", icon: TbBallFootball });
		return options;
	}

	if (!fullTimeAt) {
		if (!halfTimeAt) {
			options.push({
				id: "half-time",
				label: "Half time",
				icon: TbBallFootball,
			});
		} else if (!secondHalfStartTime) {
			options.push({
				id: "second-half",
				label: "Start second half",
				icon: TbBallFootball,
			});
		} else {
			options.push({
				id: "full-time",
				label: "Full time",
				icon: TbBallFootball,
			});
		}

		options.push({
			id: "var-review",
			label: varReview ? "End VAR review" : "VAR review",
			icon: HiTv,
		});

		options.push({
			id: "time-correction",
			label: "Correct time",
			icon: TbClockQuestion,
		});
	}

	return options;
};
